import React from 'react';
import './Footer.css';
import CookieManager from "../../managers/CookieManager";

export default class Footer extends React.Component {

    state = {
        numberOfClick: 0
    };

    onFooterClick() {
        if (this.state.numberOfClick < 9) {
            this.setState({numberOfClick: this.state.numberOfClick + 1});
            return;
        }

        const testerMode = CookieManager.testerMode;
        CookieManager.testerMode = !testerMode;

        this.setState({numberOfClick: 0})
    }

    render() {
        const style = {
            color: CookieManager.testerMode
                ? "var(--ex-green)"
                : "var(--ex-grey)"
        };

        return (
            <div className="FooterBlock"
                 style={style}
                 onClick={() => this.onFooterClick()}>

                {'\u00A9'}&nbsp;{Date().split` `[3]}. Explainit. {CookieManager.testerMode ? "Tester mode" : "All Rights Reserved"}

            </div>
        );
    }
}